module.exports = __webpack_public_path__ + "img/NU.59043cff.svg";